import Controls from "./controls";
import InputFieldsGroup from "./input-fields-group";

class UiAction {
  constructor(
    uiActionMainContainerSelector,
    radioButtonsGroupSelector,
    uiActionInputFieldsContainerSelector,
    controlsOptions = null,
    inputFieldsGroupOptions = null
  ) {
    this.uiActionMainContainerSelector = uiActionMainContainerSelector;
    this.radioButtonsGroupSelector = radioButtonsGroupSelector;
    this.uiActionInputFieldsContainerSelector = uiActionInputFieldsContainerSelector;
    this.controlsOptions = controlsOptions;
    this.inputFieldsGroupOptions = inputFieldsGroupOptions;

    this.inputFieldsGroup = new InputFieldsGroup(
      this.uiActionInputFieldsContainerSelector,
      this.uiActionMainContainerSelector,
      this.inputFieldsGroupOptions
    );
    this.controls = new Controls(
      this.uiActionMainContainerSelector,
      this.radioButtonsGroupSelector,
      this.inputFieldsGroup,
      this.controlsOptions
    );
  }

  attach = () => {
    this.controls.attach();
  };

  detach = () => {
    this.controls.detach();
  };
}

export default UiAction;
